const PolicyConnect = 'PolicyConnect';
const SafeTripBuilder = 'SafeTripBuilder';

export default {
  PolicyConnect,
  SafeTripBuilder
};
